"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeprecationService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var DeprecationService = /** @class */ (function () {
    function DeprecationService() {
        this.warningsPrinted = 0;
    }
    DeprecationService_1 = DeprecationService;
    /**
     * Prints out a warning of a future deprecation with an example of how to use the new SeismicCommon replacement
     * method
     * @param message
     * @param commonServiceName The Seismic Common service to use instead
     * @param methodName The Seismic Common Service method to use instead
     */
    DeprecationService.prototype.trace = function (message, commonServiceName, methodNameOrNames) {
        this.printMessage('trace', message, commonServiceName, methodNameOrNames);
    };
    /**
     * Prints out a warning of a future deprecation with an example of how to use the new SeismicCommon replacement
     * method
     * @param message
     * @param commonServiceName The Seismic Common service to use instead
     * @param methodName The Seismic Common Service method to use instead
     */
    DeprecationService.prototype.log = function (message, commonServiceName, methodNameOrNames) {
        this.printMessage('log', message, commonServiceName, methodNameOrNames);
    };
    /**
     * Prints out a warning of a future deprecation with an example of how to use the new SeismicCommon replacement
     * method
     * @param message
     * @param commonServiceName The Seismic Common service to use instead
     * @param methodName The Seismic Common Service method to use instead
     */
    DeprecationService.prototype.warn = function (message, commonServiceName, methodNameOrNames) {
        this.printMessage('warn', message, commonServiceName, methodNameOrNames);
    };
    /**
     * Prints out a warning of a future deprecation with an example of how to use the new SeismicCommon replacement
     * method
     * @param message
     * @param commonServiceName The Seismic Common service to use instead
     * @param methodName The Seismic Common Service method to use instead
     */
    DeprecationService.prototype.info = function (message, commonServiceName, methodNameOrNames) {
        this.printMessage('info', message, commonServiceName, methodNameOrNames);
    };
    DeprecationService.prototype.printMessage = function (consoleMethod, message, commonServiceName, methodNameOrNames) {
        var exampleMessage = '';
        var variableName = DeprecationService_1.toCamelCase(commonServiceName);
        var methodNames = Array.isArray(methodNameOrNames) ? methodNameOrNames : [methodNameOrNames];
        methodNames.forEach(function (name) { return exampleMessage += variableName + "." + name + "(...args);\n"; });
        var warningMessage = "Deprecation Warning: " + message + ". Use the " + commonServiceName + " instead.\n\nExample:\n\nimport {instance, " + commonServiceName + "} from 'seismic-common';\n\n\nconst " + variableName + " = instance.getService(" + commonServiceName + ");\n\n" + exampleMessage + "\n\t\t";
        console[consoleMethod](warningMessage);
        this.warningsPrinted++;
    };
    DeprecationService.toCamelCase = function (str) {
        return str.replace(/(?:^\w|[A-Z]|\b\w)/g, function (word, index) {
            return index === 0 ? word.toLowerCase() : word.toUpperCase();
        }).replace(/\s+/g, '');
    };
    var DeprecationService_1;
    DeprecationService = DeprecationService_1 = __decorate([
        CommonService_decorator_1.CommonService('DeprecationService')
    ], DeprecationService);
    return DeprecationService;
}());
exports.DeprecationService = DeprecationService;
//# sourceMappingURL=Deprecation.service.js.map